import React from 'react'
import { Message } from './types'
import MessageCard from './message-card'
import AttachmentMessageCard from './attachment-message-card'

interface MessageWithAttachmentCardProps {
  message: Message
  showTimestamp: boolean
  getStatusIcon: (message: Message) => JSX.Element | string
  formatTimestamp: (timestamp: string) => string
  backgroundColor: string
  isGroupChat?: boolean
  isFirstInGroup?: boolean
}

const MessageWithAttachmentCard: React.FC<MessageWithAttachmentCardProps> = ({
  message,
  showTimestamp,
  getStatusIcon,
  formatTimestamp,
  backgroundColor,
  isGroupChat = false,
  isFirstInGroup = false,
}) => {
  return (
    <div className="w-100">
      {/* Render text message first */}
      <MessageCard
        message={{ ...message, attachments: [], has_attachments: false }} // Remove attachments for text-only card
        showTimestamp={showTimestamp}
        getStatusIcon={getStatusIcon}
        formatTimestamp={formatTimestamp}
        backgroundColor={backgroundColor}
        isGroupChat={isGroupChat}
        isFirstInGroup={isFirstInGroup}
      />

      {/* Render attachment card below (without text and timestamp) */}
      <div style={{ marginTop: 'clamp(4px, 1vw, 8px)' }}>
        <AttachmentMessageCard
          message={{ ...message, text: '' }} // Remove text since it's already shown above
          showTimestamp={false}
          getStatusIcon={getStatusIcon}
          formatTimestamp={formatTimestamp}
          isGroupChat={isGroupChat}
          isFirstInGroup={false}
        />
      </div>
    </div>
  )
}

export default MessageWithAttachmentCard
